import { RouteProp, useNavigation, useRoute } from '@react-navigation/native';
import { useCallback, useState } from 'react';
import { useRecoilValue } from 'recoil';

import { BatchTicketCartKeys, SignedInRootStackParamList } from '../../../routes/types';
import { useBatchTicketActions } from '../../../store/batchTicket/actions';
import {
  customerCartCountSelector,
  productsCartCountSelector,
} from '../../../store/batchTicket/selectors';
import { AddedCustomers } from '../components/Cart/components/AddedCustomers';
import { AddedProducts } from '../components/Cart/components/AddedProducts';

import { useStep } from './useStep';

export const useBatchTicketCart = () => {
  const tabs = [
    {
      key: 'addedCustomers',
      label: 'Clientes adicionados',
      component: <AddedCustomers />,
    },
    {
      key: 'addedProducts',
      label: 'Produtos adicionados',
      component: <AddedProducts />,
    },
  ] as const;

  const { continueButtonIsDisabled, goToNextStep } = useStep();

  const { params } = useRoute<RouteProp<SignedInRootStackParamList, 'BatchTicketCart'>>();

  const { canGoBack, goBack } = useNavigation();
  const { onChangeCustomerCartStatus } = useBatchTicketActions();

  const customerCartCount = useRecoilValue(customerCartCountSelector);
  const productsCartCount = useRecoilValue(productsCartCountSelector);

  const customerCartIsEmpty = customerCartCount === 0;
  const productsCartIsEmpty = productsCartCount.assets === 0;

  const [selectedTab, setSelectedTab] = useState<BatchTicketCartKeys>(params?.key || tabs[0].key);

  const getSliderModalWidth = (isDesktop: boolean) => (isDesktop ? 0.8 : 1);

  const handleGoBack = useCallback(() => {
    if (canGoBack()) {
      goBack();
    }
  }, [canGoBack, goBack]);

  const basketSectionItemCount =
    selectedTab === 'addedCustomers' ? customerCartCount : productsCartCount.assets;

  const footerSectionIsVisible =
    (selectedTab === 'addedCustomers' && !customerCartIsEmpty) ||
    (selectedTab === 'addedProducts' && !productsCartIsEmpty);

  const handleAddItem = () => {
    onChangeCustomerCartStatus(selectedTab === 'addedCustomers' ? 'start' : 'complete');
    handleGoBack();
  };

  return {
    tabs,
    basketSectionItemCount,
    selectedTab,
    continueButtonIsDisabled,
    getSliderModalWidth,
    handleGoBack,
    onTabPress: setSelectedTab,
    goToNextStep,
    handleAddItem,
    footerSectionIsVisible,
  };
};
